import React from 'react';
import Icon from '../ui/Icon';
import { useApp } from '../../context/AppContext';

const NAV_TABS = [
  { id: 'dashboard',  icon: 'home',     label: 'Home'       },
  { id: 'requests',   icon: 'list',     label: 'Requests'   },
  { id: 'new',        icon: 'plus',     label: 'New Request' },
  { id: 'tickets',    icon: 'ticket',   label: 'Tickets'    },
  { id: 'wallet',     icon: 'wallet',   label: 'Wallet'     },
];

const BottomNav = () => {
  const { activeTab, setActiveTab } = useApp();

  return (
    <nav className="flex-shrink-0 h-[70px] bg-surface-800 border-t border-surface-500 flex items-center justify-around px-2 relative z-10">
      {/* Subtle top highlight */}
      <div className="absolute top-0 left-1/4 right-1/4 h-px bg-gradient-to-r from-transparent via-brand-400/20 to-transparent" />

      {NAV_TABS.map((tab) => {
        const active = activeTab === tab.id;
        const isNew  = tab.id === 'new';

        if (isNew) {
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab('new')}
              className="relative -mt-5 flex flex-col items-center press-scale"
            >
              <div
                className="w-14 h-14 rounded-2xl flex items-center justify-center brand-glow"
                style={{
                  background: 'linear-gradient(135deg, #4338ca 0%, #6366f1 60%, #818cf8 100%)',
                  boxShadow: '0 0 24px rgba(99,102,241,0.35), 0 4px 16px rgba(99,102,241,0.2)',
                }}
              >
                <Icon name="plus" size={24} className="text-white" strokeWidth="2.5" />
              </div>
              <span className="text-xs font-dm font-medium text-surface-200 mt-1">{tab.label}</span>
            </button>
          );
        }

        return (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className="flex flex-col items-center gap-1 px-3 py-2 press-scale"
          >
            <span className={`transition-colors duration-200 ${active ? 'text-brand-600' : 'text-surface-300'}`}>
              <Icon name={tab.icon} size={20} strokeWidth={active ? '2.5' : '2'} />
            </span>
            <span className={`text-xs font-dm font-medium transition-colors duration-200 ${active ? 'text-brand-600' : 'text-surface-300'}`}>
              {tab.label}
            </span>
            {active && (
              <span className="w-1 h-1 rounded-full bg-brand-600 -mt-0.5" />
            )}
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
